import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppNavbar, AppFooter, AppWhatsApp } from "@/components/AppChrome";
import Home from "@/pages/Home";
import About from "@/pages/About";
import BotanicalExtracts from "@/pages/BotanicalExtracts";
import SpicesSeedsGrains from "@/pages/SpicesSeedsGrains";
import CoffeeBeans from "@/pages/CoffeeBeans";
import EcoPackaging from "@/pages/EcoPackaging";
import EcoExperience from "@/pages/EcoExperience";
import EssentialOils from "@/pages/EssentialOils";
import Quality from "@/pages/Quality";
import Certifications from "@/pages/Certifications";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ChangePassword from "@/pages/ChangePassword";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppNavbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products/botanical-extracts" element={<BotanicalExtracts />} />
              <Route path="/products/spices-seeds-grains" element={<SpicesSeedsGrains />} />
              <Route path="/products/coffee-beans" element={<CoffeeBeans />} />
              <Route path="/products/eco-packaging" element={<EcoPackaging />} />
              <Route path="/products/eco-packaging/experience" element={<EcoExperience />} />
              <Route path="/products/essential-oils" element={<EssentialOils />} />
              <Route path="/quality" element={<Quality />} />
              <Route path="/certifications" element={<Certifications />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/change-password"
                element={
                  <ProtectedRoute>
                    <ChangePassword />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <AppFooter />
          <AppWhatsApp />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
